import React from 'react';
import styled from 'styled-components';

import Image from 'partials/Image';

export default props => {
    const { data } = props;

    if(!data) return null;
    
    return (
        <ImageWidget>
            <Image image={data} useWindowSize />
        </ImageWidget>
    );
}

const ImageWidget = styled.li`
    position:relative;
    list-style: none;
    img {
        margin-bottom:50px;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/RichText/ImageWidget.js